export default __webpack_public_path__ + "static/media/O-029.e4da4aa2.png";